<div class="view-actions" [ngClass]="{ 'overlay': mode == 'transparent', 'primary': mode == 'primary', 'white': mode == 'white' }">
  <ng-content></ng-content>
</div>
